/* esm.sh - typeforce@1.18.0 */
import "/node/buffer.mjs";
export * from "/*typeforce@1.18.0/esnext/typeforce.mjs";
export { default } from "/*typeforce@1.18.0/esnext/typeforce.mjs";
